export default __webpack_public_path__ + "static/media/m_miguel.42a77256.png";